import { useIntl } from 'react-intl';

export const GetKindOptions = (): { id: string; name: string }[] => {
	const { formatMessage } = useIntl();

	return [
		{
			id: 'map',
			name: formatMessage({ id: 'modules.mapsFiguresOverview.filter.map' })
		},
		{
			id: 'figure',
			name: formatMessage({ id: 'modules.mapsFiguresOverview.filter.figure' })
		}
	];
};
